import React, { useState } from 'react';

// 绑定/关联清单模态内容: 可筛选 + 逐项点击跳转 (材料详情 / 设备工况 / 参数行)。
// Schema 管理三种模板 (材料 / 设备 / 参数) 的"关联""存值"清单共用本组件。

/** 清单项: 展示名 + 业务编码 (后端 BoundItem 同构)。 */
export interface BindingListItem {
    name: string;
    code: string;
}

function BindingList({
    items,
    unit,
    onPick,
}: {
    items: BindingListItem[];
    unit: string;
    onPick: (code: string) => void;
}) {
    const [q, setQ] = useState('');
    const ql = q.trim().toLowerCase();
    const shown = ql
        ? items.filter(
              (it) => it.name.toLowerCase().includes(ql) || it.code.toLowerCase().includes(ql),
          )
        : items;
    return (
        <div className="space-y-2">
            {items.length > 8 && (
                <input
                    className="inp w-full text-sm"
                    placeholder={`筛选${unit} (名称 / 编码)…`}
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    autoFocus
                />
            )}
            <div className="max-h-[62vh] overflow-auto grid gap-1.5 -mx-0.5 px-0.5">
                {shown.map((it) => (
                    <button
                        key={it.code}
                        type="button"
                        onClick={() => onPick(it.code)}
                        className="group flex items-center justify-between gap-3 w-full text-left px-3 py-2 rounded-lg border border-slate-100 bg-slate-50/60 hover:border-brand-300 hover:bg-brand-50 transition-colors"
                    >
                        <span className="min-w-0">
                            <span className="block text-sm text-slate-700 truncate">{it.name}</span>
                            <span className="font-mono text-[11px] text-slate-400">{it.code}</span>
                        </span>
                        <span className="shrink-0 text-xs text-brand-500 opacity-0 group-hover:opacity-100 transition-opacity">
                            查看 ↗
                        </span>
                    </button>
                ))}
                {shown.length === 0 && (
                    <div className="text-center text-sm text-slate-400 py-6">无匹配{unit}</div>
                )}
            </div>
        </div>
    );
}

export default BindingList;
